
<div class="order-ticket p-3">
    <div class="order-ticket-body _h-auto">
        <div class="ticket-box text-center" *ngIf="!$storage.isDelivery">
            <h4>{{'PO.TABLE_BILL' | translate}} {{$storage.order.printData.variables.TABLE_NO}}</h4>
            <div class="mt-1">{{'PO.WAITER' | translate}} {{$storage.order.printData.variables.F_NAME}} {{$storage.order.printData.variables.L_NAME && $storage.order.printData.variables.L_NAME[0]}}</div>
            <hr />
        </div>
        <ng-container *ngIf="$storage.isOTC">
            <div class="ticket-box text-center">
                <div>
                    {{'PO.ORDER_NO' | translate}}:&nbsp;<div class="inline">{{$storage.order.printData.variables.ORDER_NO}}</div>
                </div>
                <div>
                    {{'PO.ORDERER_NAME' | translate}}:&nbsp;<div class="inline">{{$storage.order.printData.variables.ORDERER_NAME}}</div>
                </div>
                <div>
                    {{'PO.ORDERER_PHONE' | translate}}:&nbsp;<div class="inline">{{$storage.order.printData.variables.ORDERER_TEL}}</div>
                </div>
                <div *ngIf="$storage.$deliveryAddress">
                    {{'PO.ORDER_TO' | translate}}:&nbsp;<div class="inline">{{$storage.$deliveryAddress}}</div>
                </div>
                <hr />
            </div>
        </ng-container>

        <ng-container  *ngIf="$storage.showPrices">
            <div class="ticket-box">

                <ng-container *ngIf="isUS">
                    <table class="ticket-box-table _md">
                        <tr>
                            <th>{{'PO.ORDER_TOTAL' | translate}}</th>
                            <td>{{$storage.order.printData.variables.TOTAL_AMOUNT | number:'1.2-2'}}</td>
                        </tr>

                        <tr *ngIf="$storage.order.printData.variables.ORDER_ON_THE_HOUSE == '1'">
                            <th colspan="2">{{'PO.TICKET_OTH' | translate}}</th>
                        </tr>

                        <tr *ngIf="$storage.order.printData.variables.TOTAL_PAYMENTS">
                            <th>{{'PO.PAID' | translate}}</th>
                            <td>{{($storage.order.printData.variables.TOTAL_PAYMENTS - $storage.order.printData.variables.CHANGE) | number:'1.2-2'}}</td>
                        </tr>
                        <tr *ngIf="$storage.order.printData.variables.CHANGE">
                            <th>{{'PO.CHANGE' | translate}}</th>
                            <td>{{$storage.order.printData.variables.CHANGE | number:'1.2-2'}}</td>
                        </tr>
                        <tr class="font-bold" *ngIf="$storage.order.printData.variables.BAL_DUE !== $storage.order.printData.variables.TOTAL_AMOUNT">
                            <th>{{'PO.REMAINED_PAY' | translate}}</th>
                            <td>{{$storage.order.printData.variables.BAL_DUE | number:'1.2-2'}}</td>
                        </tr>
                    </table>
                </ng-container>

                <table class="ticket-box-table _md" *ngIf="!isUS">
                    <tr>
                        <th>{{'PO.ORDER_TOTAL' | translate}}</th>
                        <td>{{$storage.order.printData.variables.TOTAL_AMOUNT | number:'1.2-2'}}</td>
                    </tr>
                    <tr *ngIf="$storage.order.printData.variables.ORDER_ON_THE_HOUSE == '1'">
                        <th colspan="2">{{'PO.TICKET_OTH' | translate}}</th>
                    </tr>
                    <tr *ngIf="$storage.order.printData.variables.TOTAL_TIPS">
                        <th>{{'PO.ORDER_TIP' | translate}}</th>
                        <td>{{$storage.order.printData.variables.TOTAL_TIPS | number:'1.2-2'}}</td>
                    </tr>
                    <tr *ngIf="$storage.order.printData.variables.TOTAL_PAYMENTS">
                        <th>{{'PO.PAID' | translate}}</th>
                        <td>{{($storage.order.printData.variables.TOTAL_PAYMENTS - $storage.order.printData.variables.CHANGE) | number:'1.2-2'}}</td>
                    </tr>
                    <tr *ngIf="$storage.order.printData.variables.CHANGE">
                        <th>{{'PO.CHANGE' | translate}}</th>
                        <td>{{$storage.order.printData.variables.CHANGE | number:'1.2-2'}}</td>
                    </tr>
                    <tr class="font-bold" *ngIf="$storage.order.printData.variables.BAL_DUE !== $storage.order.printData.variables.TOTAL_AMOUNT">
                        <th>{{'PO.REMAINED_PAY' | translate}}</th>
                        <td>{{$storage.order.printData.variables.BAL_DUE | number:'1.2-2'}}</td>
                    </tr>
                </table>
            </div>

            <div class="ticket-box" *ngIf="isUS">
                <hr/>
                <table class="ticket-box-table _md">
                    <tr>
                        <th>{{'Subtotal' | translate}}</th>
                        <td>{{$storage.order.printData.variables.INCLUSIVE_NET_AMOUNT | number:'1.2-2'}}</td>
                    </tr>
                    <tr *ngIf="$storage.order.fees">
                        <th>{{'Fees' | translate}}</th>
                        <td>{{$storage.order.fees | number:'1.2-2'}}</td>
                    </tr>
                    <tr class="" *ngIf="$storage.order.autoGratuity">
                        <th>{{$storage.order.autoGratuity.name}}</th>
                        <td>{{$storage.order.autoGratuity.amount | number:'1.2-2'}}</td>
                    </tr>
                    <tr *ngIf="args.totalTips">
                        <th>{{'PO.ORDER_TIP' | translate}}</th>
                        <td>{{args.totalTips | number:'1.2-2'}}</td>
                    </tr>
                    <tr *ngIf="$storage.order.totals.totalExcludedTax">
                        <th>
                            {{'Sales Tax' | translate}}
                        </th>
                        <td>
                            {{($storage.order.totals.totalExcludedTax / 100) | number:'1.2-2'}}
                        </td>
                    </tr>
                </table>
            </div>
        </ng-container>

    </div>


    <div class="order-ticket-header">{{'split_amount_topay' | translate}}</div>

    <div>
        <div class="order-ticket-check" [class._paid]="!check.$$balanceDue" *ngFor="let check of $storage.order.checks; let index = index" (mousedown)="_onCheckSelect(check)">
            <div class="mr-4 flex-grow-1" style="overflow:hidden">

                <div class="_table">
                    <div [class.first]="!check.$$balanceDue || check.$$balanceDue == check.$$total">
                        <div class="_cap">{{appService.translate('split_check_name', {v: check.number})}}</div>
                        <div class="_amount">{{(check.$$total) | lcurrency:'1.2-2'}}</div>
                    </div>
                    <div class="first" *ngIf="check.$$balanceDue && check.$$balanceDue != check.$$total">
                        <div class="_cap">{{'PO.REMAINED_PAY' | translate}}</div>
                        <div class="_amount">{{check.$$balanceDue | lcurrency}}</div>
                    </div>

                    <ng-container *ngIf="check.payments?.length">
                        <hr class="m-0" />
                        <ng-container *ngFor="let pm of check.payments">
                            <div class="_more" *ngIf="pm">
                                <div class="_cap">{{pm.name | translate}}</div>
                                <div class="_tip ml-2" *ngIf="pm.tip">
                                    (<span class="inline">{{'gratuity' | translate}}: </span>
                                    {{pm.tip | lcurrency:'1.2-2'}})
                                </div>
                                <div class="_amount ml-2">{{pm.total | lcurrency:'1.2-2'}}</div>
                            </div>
                        </ng-container>
                    </ng-container>
                </div>
            </div>
            <mat-icon class="lg" *ngIf="check.$$balanceDue">{{appService.nextIcon}}</mat-icon>
            <mat-icon class="lg text-accent" *ngIf="!check.$$balanceDue" svgIcon="check"></mat-icon>
        </div>
    </div>


    <!--<img style="width:20%; display:block; margin: 25px auto 0 auto" *ngIf="$storage.siteLogoURL" src="{{$storage.siteLogoURL}}" onerror="this.style.display = 'none'"/>-->


    <div class="text-center" style="margin-top: 20px">
        <div class="ticket-box-powered">
			<div class="no-wrap">Powered By</div>
			<img src="/assets/images/logo-light.svg" />
        </div>
    </div>


</div>
